<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title style="padding: 0px">
        <v-layout row>
          <v-flex sm6>
            <v-breadcrumbs icons divider="chevron_right">
              <v-breadcrumbs-item
                icons
                router
                :to="item.path"
                v-for="item in racourcis"
                :key="item.text"
                :disabled="item.disabled"
                >{{ item.text }}</v-breadcrumbs-item
              >
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <br />

    <v-layout row class="elevation-6 pt-4 mb-3">
      <v-flex sm5 offset-xs2 class="text-xs-right">
        <el-form
          label-position="left"
          :inline="true"
          :model="formTri"
          class="demo-form-inline"
        >
          <el-form-item label="Période de recherche" style="width: 100%">
            <el-date-picker
              style="width: 100%"
              v-model="formTri.periode"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              type="datetimerange"
              range-separator="à"
              start-placeholder="Début date"
              end-placeholder="Fin date"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </v-flex>
      <v-flex sm3>
        <v-tooltip bottom>
          <v-btn
            @click="recherche()"
            slot="activator"
            class="white--text"
            color="blue"
            fab
            small
            :disabled="desactiveBout"
          >
            <v-icon>search</v-icon> </v-btn
          >Effectuer une recherche
        </v-tooltip>
      </v-flex>
    </v-layout>

    <!-- widget -->
    <v-layout row mt-2 mb-4 ml-1>
      <v-flex sm12>
        <WidgetTravaux  :commis="false" :listeTrx="listeTravaux" :listeTrxId ="listeTravauxId"></WidgetTravaux>
      </v-flex>
    </v-layout>

    <!-- TAB CHANTIER -->
    <v-layout row>
      <v-flex sm12 ml-1 mr-1 mt-1>
        <v-card>
          <el-tabs
            v-model="onglet"
            type="border-card"
            @tab-click="handleTabClick(onglet)"
          >
            <el-tab-pane label="Travaux">
              <!-- RESULATS TRAVAUX -->
              <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
              <ListeTravaux
                :type="0"
                :listeTrx="listeTravaux"
                :listeTrxId ="listeTravauxId"
                :periode="periodeFormat"
                @reloadListeTravaux="loadTravaux()"
              ></ListeTravaux>
              <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
              <br />
            </el-tab-pane>

            <el-tab-pane label="Reserve Travaux">
              <!-- RESULATS RESERVE TRAVAUX -->
              <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
              <ListeReserve
                :type="0"
                :listeReserveTrx="listeReserves"
                @reloadListeReserve="loadReserves()"
              ></ListeReserve>
              <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
              <br />
            </el-tab-pane>
          </el-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ListeReserve from "@/components/rapport/ListeReserve";
import ListeTravaux from "@/components/boardTravaux/ListeTravaux";
import WidgetTravaux from "@/components/boardTravaux/widgetTravaux";
import Loading from "@/components/Loading";
export default {
  components: { Loading, ListeReserve, ListeTravaux, WidgetTravaux },
  name: "DashboardTravaux",
  props: {
    show: {
      type: Boolean
    },
    detailChantier: {
      type: Object
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      racourcis: [
        { path: "/boardTravaux'", text: "BOARD TRAVAUX", disabled: false }
      ],

      dialogDashboardChantier: false,
      loading: false,
      onglet: "0",
      listeTravaux: [],
      listeTravauxId: [],
      //ONGLET TRAVAUX
      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      listeRapports: [],
      periodeFormat: "",

      //ONGLET RESERVE
      listeReserves: [],

      //DASHBOARD TRAVAUX
      formTri: {
        periode: null
      }
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },

    loadTravaux(periode = 0) {
      let url = "";
      console.log('his.user.fonction == ',this.user.fonction)
      if (this.user.fonction == "Super Administrateur") {
        url = this.domaine + "travaux/user/admin?periode=" + periode;
      } else {
        url = this.domaine + "travaux/user/" + this.user.id + "/" + periode;
      }
      console.log(' == ',url)

      this.loading = true;
      this.listeTravauxId = []
      this.$http.get(url).then(
        response => {
          this.listeTravaux = response.body.travaux;
          this.listeTravaux.forEach(element => {
            this.listeTravauxId.push(element.idTrx)
          });
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des travaux");
        }
      );
    },

    //ONGLET RESERVE
    loadReserves(periode = 0) {
      this.loading = true;
      let url =
        this.domaine + "reserve/cheftravaux/" + this.user.id + "/" + periode;
      this.$http.get(url).then(
        response => {
          this.listeReserves = response.body.reserves;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des reserves");
        }
      );
    },

    recherche() {
      let periode = this.formTri.periode;
      let dateDbt = new Date(periode[0]);
      let dateFin = new Date(periode[1]);

      this.periodeFormat =
        "DU " +
        dateDbt.toLocaleDateString("fr-FR") +
        " AU " +
        dateFin.toLocaleDateString("fr-FR");
      this.loadTravaux(periode);
      this.loadReserves(periode);
    },

    handleTabClick(tab) {
      switch (tab) {
        case "0":
          if (this.listeTravaux.length == 0) {
            //this.loadTravaux(this.detailChantier);
          }

          break;
        case "1":
          if (this.listeReserves.length == 0) {
            //this.loadReserves();
          }
          break;

        default:
          break;
      }
    }
  },
  computed: {
    desactiveBout: function() {
      return this.formTri.periode == undefined;
    }
  },
  mounted() {
    this.periodeFormat = " DES 3 DERNIERS MOIS";
    this.loadTravaux();
    this.loadReserves();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/boardTravaux/DashboardTravaux.vue